<template>
  <div class="footer">
    <div class="footer-top">
      <div class="top_1">
        <div class="top_1-img">
          <!-- <el-image :src="$store.state.logoImage"></el-image> -->
          <div class="top_1-title"><i style="font-weight: 900">DKP评级</i></div>
        </div>
        <div class="top_1-text">坚持服务是我们的唯一产品</div>
      </div>
      <div class="top_2">
        <div class="top_2-li">Pages</div>
        <div class="top_2-li" @click="doAbout">关于我们</div>
        <div class="top_2-li" @click="doCooperate">DKP服务</div>
        <!-- <div class="top_2-li" @click="doTeam">鉴定团队</div> -->
        <div class="top_2-li" @click="doContact">联系我们</div>
        <div class="top_2-li" style="padding: 0" @click="doIdentify">
          鉴定服务
        </div>
      </div>
      <div class="top_2" style="margin-right: 9.58%">
        <div class="top_2-li">Services</div>
        <div
          class="top_2-li"
          v-for="(item, index) in dataList"
          :key="index"
          @click="doPierre(item.id)"
        >
          {{ item.optionName }}
        </div>
        <!-- <div class="top_2-li" @click="doPierre('1')">邮票</div>
        <div class="top_2-li" @click="doPierre('0')">纸钞</div>
        <div class="top_2-li" @click="doPierre('2')">古钱币</div> -->
        <div class="top_2-li" style="padding: 0" @click="doPostalCurrency">
          邮币文创
        </div>
      </div>
      <div class="top_3">
        <div class="top_3-li">Contact</div>
        <div class="top_3-li">
          <el-image
            :src="require('../../assets/images/dianhua.png')"
          ></el-image>
          <div>电话：{{ list.contactPhone }}</div>
        </div>
        <div class="top_3-li">
          <el-image
            :src="require('../../assets/images/youxiang.png')"
          ></el-image>
          <div>邮箱： {{ list.contactEmail }}</div>
        </div>
        <div class="top_3-li">
          <el-image
            :src="require('../../assets/images/gongxuoshijian.png')"
          ></el-image>
          <div>工作时间：{{ list.workHours }}</div>
        </div>
        <div class="top_3-li">
          <el-image :src="require('../../assets/images/dizhi.png')"></el-image>
          <div>地址：{{ address }}</div>
        </div>
        <div class="top_3-li">
          <a href="https://beian.miit.gov.cn">苏ICP备2023018769号-2</a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      ©2023 All rights reserved. Reliance Retail Ltd.
    </div>
  </div>
</template>
<script>
import { collectionGetUsedAll } from "../../api/selectionOfCollections";
import { getAboutUs } from "../../utils/anth";
import { webGetContactUs } from "../../api/companyProfile";
export default {
  data() {
    return {
      dataRform: "",
      dataList: [],
      address: "",
      list: {},
    };
  },
  created() {
    // if (getAboutUs() != undefined) {
    //   this.dataRform = JSON.parse(getAboutUs());
    // }
    this.webGetContactUs();
    this.collectionGetUsedAll();
    // console.log(this.dataRform,'dataRform>>');
  },
  methods: {
    webGetContactUs() {
      webGetContactUs().then((res) => {
        if (res.code == "success") {
          let data = res.data;
          console.log(data);
          this.list = res.data != null ? res.data : this.list;
          this.address = this.handleAddress(
            data.provincesCities,
            data.contactAddress
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddress(provincesCities, contactAddress) {
      let data = JSON.parse(provincesCities);
      var dataAdd = "";
      for (let i = 0; i < data.length; i++) {
        dataAdd += data[i];
      }
      return dataAdd + contactAddress;
    },
    // 查询甄选藏品的目录
    collectionGetUsedAll() {
      collectionGetUsedAll({ page: null, limit: null }).then((res) => {
        if (res.code === "success") {
          this.dataList = res.data.splice(0, 4);
          // console.log(this.dataList, "dataList");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关于我们
    doAbout() {
      this.$router.push({
        path: "/companyOverview",
      });
      this.$store.dispatch("dispatchNavIndex", "companyOverview");
    },
    // dkp服务
    doCooperate() {
      this.$router.push({
        path: "/chargingStandards",
      });
      this.$store.dispatch("dispatchNavIndex", "chargingStandards");
    },
    // 鉴定团队
    doTeam() {
      this.$router.push({
        path: "/companyOverview",
      });
      this.$store.dispatch("dispatchNavIndex", "companyOverview");
    },
    // 联系我们
    doContact() {
      this.$router.push({
        path: "/contactUs",
      });
      this.$store.dispatch("dispatchNavIndex", "contactUs");
    },
    // 鉴定服务
    doIdentify() {
      this.$router.push({
        path: "/ratingQuery",
      });
      this.$store.dispatch("dispatchNavIndex", "ratingQuery");
    },
    // 纪念币
    doPierre(id) {
      this.$router.push({
        path: "/premiumCisplay",
        query: {
          id: id,
        },
      });
      this.$store.dispatch("dispatchNavIndex", "premiumCisplay");
    },
    // 邮币文创
    doPostalCurrency() {
      this.$router.push({
        path: "/culturalAndCreative",
      });
      this.$store.dispatch("dispatchNavIndex", "culturalAndCreative");
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: auto;

  .footer-top {
    width: 100%;
    height: 321px;
    background-color: #070907;
    padding-top: 42px;
    display: flex;
    justify-content: center;
    opacity: 0.96;

    .top_1 {
      width: auto;
      height: auto;
      margin-right: 7.86%;

      .top_1-img {
        width: 100%;
        height: auto;
        display: flex;
        align-items: end;

        .el-image {
          width: 57px;
          height: 57px;
        }

        .top_1-title {
          font-size: 26px;
          font-weight: 400;
          color: #ffffff;
          padding-left: 4px;
        }
      }

      .top_1-text {
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        padding-top: 14px;
      }
    }

    .top_2 {
      width: auto;
      height: auto;
      margin-right: 6.93%;

      .top_2-li {
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        padding-bottom: 26px;
        cursor: pointer;
      }
    }

    .top_3 {
      width: auto;
      height: auto;

      .top_3-li {
        width: auto;
        height: auto;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        padding-bottom: 26px;

        .el-image {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
      }
    }
  }

  .footer-bottom {
    width: 100%;
    height: 60px;
    background-color: #000000;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 1680px) {
    .footer-top {
      height: 321px;
      padding-top: 42px;

      .top_1 {
        .top_1-img {
          .el-image {
            width: 57px;
            height: 57px;
          }

          .top_1-title {
            font-size: 26px;
            padding-left: 4px;
          }
        }

        .top_1-text {
          font-size: 18px;
          padding-top: 14px;
        }
      }

      .top_2 {
        .top_2-li {
          font-size: 18px;
          padding-bottom: 26px;
        }
      }

      .top_3 {
        .top_3-li {
          font-size: 18px;
          padding-bottom: 26px;

          .el-image {
            width: 18px;
            height: 18px;
            margin-right: 6px;
          }
        }
      }
    }

    .footer-bottom {
      height: 60px;
      font-size: 18px;
    }
  }

  @media screen and (max-width: 1366px) {
    .footer-top {
      height: 261px;
      padding-top: 30px;

      .top_1 {
        .top_1-img {
          .el-image {
            width: 46px;
            height: 46px;
          }

          .top_1-title {
            font-size: 21px;
            padding-left: 3px;
          }
        }

        .top_1-text {
          font-size: 14px;
          padding-top: 10px;
        }
      }

      .top_2 {
        .top_2-li {
          font-size: 14px;
          padding-bottom: 20px;
        }
      }

      .top_3 {
        .top_3-li {
          font-size: 14px;
          padding-bottom: 20px;

          .el-image {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
      }
    }

    .footer-bottom {
      height: 49px;
      font-size: 16px;
    }
  }

  @media screen and (max-width: 1280px) {
    .footer-top {
      height: 245px;
      padding-top: 28px;

      .top_1 {
        .top_1-img {
          .el-image {
            width: 43px;
            height: 44px;
          }

          .top_1-title {
            font-size: 20px;
            padding-left: 3px;
          }
        }

        .top_1-text {
          font-size: 13px;
          padding-top: 10px;
        }
      }

      .top_2 {
        .top_2-li {
          font-size: 13px;
          padding-bottom: 18px;
        }
      }

      .top_3 {
        .top_3-li {
          font-size: 13px;
          padding-bottom: 18px;

          .el-image {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }
      }
    }

    .footer-bottom {
      height: 46px;
      font-size: 13px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue